import { Component, Suspense } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { withTranslation } from 'react-i18next';

const PageLoader = () => (
  <Box className="w-full h-full min-h-[200px] flex items-center justify-center">
    <CircularProgress size={32} />
  </Box>
);

// Shown when a page's code could not be loaded (e.g. offline).
class PageErrorBoundaryBase extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    // navigating elsewhere gives the next page a fresh try
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey)
      this.setState({ hasError: false });
  }

  render() {
    const { t, children } = this.props;
    if (!this.state.hasError) return children;
    return (
      <Box className="w-full h-full min-h-[200px] flex flex-col gap-3 items-center justify-center p-4 text-center">
        <Typography>{t('This page could not be loaded.')}</Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>
          {t('Try again')}
        </Button>
      </Box>
    );
  }
}

const PageErrorBoundary = withTranslation()(PageErrorBoundaryBase);

/** Loading state and error fallback for pages loaded with lazyPage(). */
export const PageSuspense = ({ children, resetKey }) => (
  <PageErrorBoundary resetKey={resetKey}>
    <Suspense fallback={<PageLoader />}>{children}</Suspense>
  </PageErrorBoundary>
);
